import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditDailyCheckInListing from '@/modules/promotion/components/EditDailyCheckIn/components/EditDailyCheckInListing'

function EditDailyCheckInPage() {
	return (
		<PageContainer>
			<EditDailyCheckInListing />
		</PageContainer>
	)
}

const GuardedEditDailyCheckInPage = withUserPermission(EditDailyCheckInPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_DAILY_CHECK_IN],
})

export default GuardedEditDailyCheckInPage
